import React, { PureComponent, Fragment } from 'react';
import { withSize } from 'react-sizeme';
import { feature, merge } from 'topojson-client';
import * as d3Geo from 'd3-geo';

import topoJson from '~/assets/data/eu.topo.json';
import Icon from '~/core/scripts/components/Icon';

import './Maps.styl';

const d3 = {
  ...d3Geo
};

const noColorIds = [
  'ALA', 'ALB', 'AND', 'BLR', 'BIH', 'FRO', 'GIB', 'GRL', 'GGY', 'IMN', 'ISL', 'JEY', 'XKX', 'LIE', 'MDA', 'MCO', 'MNE', 'MKD', 'NOR', 'RUS', 'SMR', 'CHE', 'SRB', 'SJM', 'TUR', 'UKR', 'VAT'
];

const labels = [
  ['Deutschland', 51.3150233,8.0467253],
  ['Frankreich', 46.5389377,0.3765643],
  ['Italien', 42.3547184,12.2594965],
  ['Lettland', 56.8600938,22.3021486],
  ['Finnland', 62.1549625,24.5412633],
  ['Spanien', 40.0733242,-4.2758607],
  ['Polen', 51.9032083,20.0680263],
  ['Schweden', 64.7029613,15.0865803],
  ['Großbritannien', 57.1322949,-3.7037157],
  ['Zypern', 35.8377443,31.6405693],
  ['Malta', 35.5681943,14.1311833],
  ['Slowakei', 48.667044,18.5785805],
  ['Rumänien', 45.919963,22.7775614]
];

function mergeTopojsonByKey(topoJsonData, propertyKey) {
  const key = Object.keys(topoJsonData.objects)[0];
  const topoJsonObject = topoJsonData.objects[key];
  const groups = topoJsonObject.geometries
    .reduce((res, item) => {
      const currentValue = item.properties[propertyKey];

      if (!res.includes(currentValue)) {
        res.push(currentValue);
      }

      return res;
    }, [])
    .map(value =>
      merge(
        topoJsonData,
        topoJsonObject.geometries.filter(d => d.properties[propertyKey] === value)
      )
    );

  return groups;
}

class StaticMap extends PureComponent {
  renderLabel(label, projection) {
    const pos = projection([label[2], label[1]]);
    return (
      <div
        style={{
          top: `${~~pos[1]}px`,
          left: `${~~pos[0]}px`
        }}
        key={label[0]}
        className="map-label"
      >
        {label[0]}
      </div>
    );
  }

  renderSwoopy(swoopy, projection) {
    const pos = projection([swoopy.lng, swoopy.lat]);
    const swoopyStyle = swoopy.style || {};
    const iconStyle = swoopy.iconStyle || {};

    return (
      <div
        style={{
          top: `${~~pos[1]}px`,
          left: `${~~pos[0]}px`,
          ...swoopyStyle
        }}
        key={swoopy.text}
        className="map-swoopy"
      >
        <div>{swoopy.text}</div>
        <Icon type="arrow-curved" style={{ ...iconStyle }} />
      </div>
    );
  }

  render() {
    const {
      size, overlayDissolveKey, strokeWidth = 0.25, data,
      colorScale, swoopies = []
    } = this.props;

    const { width, height } = size;
    const topoKey = Object.keys(topoJson.objects)[0];
    const geojson = feature(topoJson, topoJson.objects[topoKey]);
    const geojsonVisible = { ...geojson, features : geojson.features.filter(feat => !noColorIds.includes(feat.properties.ISO3_CODE)) };
    const projection = d3.geoMercator().fitSize([width, height], noColorIds.length ? geojsonVisible : geojson);
    const geoPath = d3.geoPath().projection(projection);
    const overlayGeojson = overlayDissolveKey ? mergeTopojsonByKey(topoJson, overlayDissolveKey) : null;

    return (
      <div className="static-map">
        <svg className="static-map-svg" width={width} height={height}>
          <g className="map-layer-geometries">
          {geojson.features.map((feat, i) => {
            const hasColor = !noColorIds.includes(feat.properties.ISO3_CODE);
            const currData = data.find(d => d.key === feat.properties.CNTR_ID);

            return (
              <path
                key={`feature__${i}`}
                d={geoPath(feat)}
                fill={(hasColor && currData)? colorScale(currData.value) : '#F9F9F9'}
                stroke={hasColor ? 'transparent' : '#A3A3A3'}
                strokeWidth={strokeWidth}
              />
            );
          })}
          </g>
          {overlayDissolveKey && (
            <g className="map-layer-geometries overlay">
              {overlayGeojson.map((feat, i) => (
                <path
                  key={`feature__${i}`}
                  d={geoPath(feat)}
                  fill="transparent"
                  stroke="#fff"
                  strokeWidth={strokeWidth}
                />
              ))}
            </g>
          )}
        </svg>
        {labels.map(label => this.renderLabel(label, projection))}
        {swoopies.map(swoopy => this.renderSwoopy(swoopy, projection))}
      </div>
    );
  }
}

export default withSize({ monitorHeight: true })(StaticMap);
